import { render } from "./User-document.vue?vue&type=template&id=43170d94"
import script from "./User-document.vue?vue&type=script&lang=js"
export * from "./User-document.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__